import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// Remote
export const _ADD_BUYOUT = gql`
  mutation _AddBuyOut($projectId: ID!, $input: BuyOutInput!) {
    _addBuyOut(projectId: $projectId, buyOutInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_BUYOUT = gql`
  mutation AddBuyOut($projectId: ID!, $input: BuyOutInput!) {
    addBuyOut(projectId: $projectId, buyOutInput: $input) {
      ...BuyOut
    }
  }
  ${fragments.buyOut}
`

export const GET_BUYOUTS = gql`
  query BuyOuts($projectId: ID, $roundId: ID) {
    buyOuts(projectId: $projectId, roundId: $roundId) {
      ...BuyOut
    }
  }
  ${fragments.buyOut}
`

export const _SAVE_BUYOUT = gql`
  mutation _SaveBuyOut($buyOutId: ID!, $input: BuyOutInput!) {
    _saveBuyOut(buyOutId: $buyOutId, buyOutInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_BUYOUT = gql`
  mutation _DeleteBuyOut($buyOutId: ID!) {
    _deleteBuyOut(buyOutId: $buyOutId) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_BUYOUTS = gql`
  mutation _SaveMultipleBuyOuts($projectId: ID!, $roundId: ID!, $buyOutInputs: [BuyOutInput!]!) {
    _saveMultipleBuyOuts(projectId: $projectId, roundId: $roundId, buyOutInputs: $buyOutInputs) {
      ...Project
    }
  }
  ${fragments.project}
`

const mutations = {
  addRemote: _ADD_BUYOUT,
  saveRemote: _SAVE_BUYOUT,
  deleteRemote: _DELETE_BUYOUT,
  saveOp: '_saveBuyOut',
  addOp: '_addBuyOut',
  deleteOp: '_deleteBuyOut',
}

export const buyOutsQueries = { ...mutations, getRemote: GET_BUYOUTS }
